<template>
  <svg
    width="16px"
    height="14.4px"
    viewBox="0 0 16 14.4"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="side-menu"
        transform="translate(-32, -114)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g
          id="bar_chart_4_bars_FILL0_wght400_GRAD0_opsz24"
          transform="translate(32, 114)"
        >
          <path
            id="Shape"
            d="M0,14.4 L0,12.8 L16,12.8 L16,14.4 L0,14.4 Z M0.8,12 L0.8,6.4 L3.2,6.4 L3.2,12 L0.8,12 Z M4.8,12 L4.8,2.4 L7.2,2.4 L7.2,12 L4.8,12 Z M8.8,12 L8.8,4.8 L11.2,4.8 L11.2,12 L8.8,12 Z M12.8,12 L12.8,0 L15.2,0 L15.2,12 L12.8,12 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
